import { doGet, doPut, doPost, doDelete } from './common';

const putNotificationStatus = (id, params) => {
  return doPut(`/api/notification/${id}/status`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}
const getList = () => {
  return doGet(`/api/notification`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

export {
  getList, 
  putNotificationStatus
}